require('./brokerOrdersAndMovementsActivity.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { fromJS } = require('immutable');
// @ commons
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
// @ components
const {
    BrokerOrdersAndMovementsActivityTableRow
} = require('components/broker/brokerOrdersAndMovementsActivityTableRow/brokerOrdersAndMovementsActivityTableRow');
const BrokerOrdersAndMovementsActivityDetails = require('components/broker/brokerOrdersAndMovementsActivityDetails/brokerOrdersAndMovementsActivityDetails');
const BrokerOrdersAndMovementsActivityHeader = require('components/broker/brokerOrdersAndMovementsActivityHeader/brokerOrdersAndMovementsActivityHeader');
const BrokerOrdersAndMovementsActivityFilter = require('components/broker/brokerOrdersAndMovementsActivityFilter/brokerOrdersAndMovementsActivityFilter');
const { ModalOrderAndMovementsFilter } = require('./components/modalOrderAndMovementsFilter');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@constants
const {
    BROKER_JOINT_CONTRACTS_CRYPTO,
    BROKER_JOINT_CONTRACTS_VALUE,
    BROKER_JOINT_CONTRACTS_FUND,
    BROKER_JOINT_CONTRACTS_PLAN,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_EXTRAORDINARY,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC_NO_RESULTS,
} = require('constants/index');
const NO_RESULTS_ERRORS = ['XX_9511', 'WESEFO_00001', 'PK0170'];
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const { taggingEventHandled } = require('../../../utilities/taggingEventHandled');
const { PROC_BROKER_ORDERS_AND_MOVEMENTS } = require('utilities/tagging.js');
const language = getLanguage();

class BrokerOrdersAndMovementsActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRowId: '',
            filterSettingsOpen: false,
            openModalForNewFilters: false
        };

        this.buildTable = this.buildTable.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.requestActivities = this.requestActivities.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }

    componentDidMount() {
        const { clearFilter, selectedOption, immContract } = this.props;
        const canUpdate =
            (immContract && immContract.get('type') === BROKER_JOINT_CONTRACTS_VALUE) ||
            (selectedOption && immContract.get('type') !== BROKER_JOINT_CONTRACTS_VALUE) ||
            (immContract && immContract.get('type') === BROKER_JOINT_CONTRACTS_CRYPTO) ||
            (selectedOption && immContract.get('type') !== BROKER_JOINT_CONTRACTS_CRYPTO);

        const contractId = immContract.get('walletNumber');
        clearFilter(contractId);

        if (canUpdate) {
            if (!selectedOption) {
                this.requestActivities();
            } else {
                this.requestActivities(immContract, selectedOption.value);
            }
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { clearFilter, immContract, selectedOption } = this.props;
        const contractId = immContract.get('walletNumber');
        const selectedOptionChanged = selectedOption !== newProps.selectedOption;
        const selectedContractChanged = newProps.immContract.get('walletNumber') !== contractId;
        const canUpdate =
            (selectedContractChanged && immContract.get('type') === BROKER_JOINT_CONTRACTS_VALUE) ||
            (newProps.selectedOption &&
                selectedOptionChanged &&
                immContract.get('type') !== BROKER_JOINT_CONTRACTS_VALUE);

        if (canUpdate) {
            if (!!clearFilter) {
                clearFilter(contractId);
            }

            this.requestActivities(
                newProps.immContract,
                newProps.selectedOption && newProps.selectedOption.value
            );
        }
    }

    requestActivities(immContractUpdated, selectedOption) {
        const { immContract, getContractActivities, getRejectedActivities, history, flagBasedFeatures } = this.props;
        const ffContribution = flagBasedFeatures.get('wealth_funds_periodic_contributions');
        if(ffContribution && immContract.get('type') === BROKER_JOINT_CONTRACTS_FUND) {
            const { getNewFundMovements, immOrdersAndMovements }  = this.props
            const stateOperation = immOrdersAndMovements.get('stateOperation');
            const date = immOrdersAndMovements.get('dateForFilter')
            const isCheckContributions = immOrdersAndMovements.get('isCheckContributions') ? 'FSC,' : '';
            const isCheckSubscription = immOrdersAndMovements.get('isCheckSubscription') ? 'FSU,' : '';
            const isCheckReimbursement = immOrdersAndMovements.get('isCheckReimbursement')
            ? 'FRE,FRM,'
            : '';
            const isCheckTransfer = immOrdersAndMovements.get('isCheckTransfer') ? 'FRI,FSI,FST' : '';
            const listCode =
            isCheckContributions + isCheckSubscription + isCheckReimbursement + isCheckTransfer;
            const totalList = listCode.length;
            const codeOperation = listCode[totalList - 1] === ',' ? listCode.slice(0, totalList - 1) : listCode;
            getNewFundMovements(immContractUpdated, stateOperation, date, codeOperation);
        } else {
            getContractActivities(immContractUpdated || immContract, selectedOption, history);
            if (__CONTACT_CENTER__ && selectedOption == BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER) {
                getRejectedActivities(immContractUpdated || immContract, selectedOption);
            }
        }
    }

    handleToggleFilters() {
        const newFilterStatus = !this.state.filterSettingsOpen;

        this.setState({
            filterSettingsOpen: newFilterStatus
        });
    }

    setFilter(filters, contractId) {
        this.props.setFilter(filters, contractId);
        this.requestActivities();
    }

    clearFilter() {
        const { immContract, getContractActivities, clearFilter } = this.props;

        clearFilter(immContract.get('walletNumber'));
        getContractActivities(immContract, null, this.props.history);
    }

    handleRetry() {
        const { immContract, getContractActivities } = this.props;
        getContractActivities(immContract, null, this.props.history);
    }

    handleRowClick(rowId) {
        taggingEventHandled(PROC_BROKER_ORDERS_AND_MOVEMENTS, 'rowClick');
        this.setState(function (previousState) {
            return { expandedRowId: rowId === previousState.expandedRowId ? '' : rowId };
        });
    }

    buildError() {
        const errorMessage = formatText('broker-contractActivityError');

        const retryButton = (
            <OKButton
                id="btn_brokerOrdersAndMovementsActivity_errorMessage_retry"
                onClick={this.handleRetry}
            >
                <FormattedText value="broker-ordersAndMovementsRetry" />
            </OKButton>
        );

        return (
            <div className="broker-orders-and-movements-activity__empty-state">
                <EmptyState primaryText={errorMessage} button={retryButton} iconType="nointernet-wealth" />
            </div>
        );
    }

    buildEmptyState(error = 'broker-contractActivityEmpty') {
        return (
            <div className="broker-orders-and-movements-activity__empty-state">
                <EmptyState primaryText={formatText(error)} iconType="noitems-wealth" />
            </div>
        );
    }

    mergeActivities() {
        const { immActivities, immRejectedActivities, immContract } = this.props;
        const contractId = immContract.get('walletNumber');
        const immActivitiesById = immActivities.getIn([contractId, 'byId']);
        const immActivitiesByOrder = immActivities.getIn([contractId, 'byOrder']);

        const immRejectedActivitiesById = immRejectedActivities.getIn([contractId, 'byId']);
        const immRejectedActivitiesByOrder = immRejectedActivities.getIn([contractId, 'byOrder']);

        const planOtherActivitiesById = immActivitiesById.toJS();
        const rejectedActivitiesById = immRejectedActivitiesById.toJS();

        const combinedOtherActivitiesOrder = immActivitiesByOrder.toSet().union(immRejectedActivitiesByOrder.toSet()).toList();
        const combinedOtherActivitiesByOrder = fromJS(combinedOtherActivitiesOrder);

        const combinedOtherActivitiesId = fromJS(Object.assign({}, planOtherActivitiesById, rejectedActivitiesById));
        const combinedOtherActivitiesById = fromJS(combinedOtherActivitiesId);

        return {
            combinedOtherActivitiesByOrder,
            combinedOtherActivitiesById
        }
    }

    buildTableHeader(immContract, selectedOption) {
        const headersData = {
            [BROKER_JOINT_CONTRACTS_VALUE]: [
                { className: 'broker-orders-and-movements-activity__collapsables' },
                { component: <FormattedText value="broker-contractActivityDate" /> },
                {
                    className: 'broker-orders-and-movements-activity__order',
                    component: (
                        <FormattedText value="broker-ordersAndMovementsActivityDetailsOrderNumber" />
                    )
                },
                {
                    className: 'broker-orders-and-movements-activity__value',
                    component: <FormattedText value="broker-contractActivityValue" />
                },
                {
                    className: 'broker-orders-and-movements-activity__operation',
                    component: <FormattedText value="broker-contractActivityOperation" />
                },
                {
                    className: 'broker-orders-and-movements-activity__state',
                    component: <FormattedText value="broker-contractActivityState" />
                },
                { clear: true }
            ],
            [BROKER_JOINT_CONTRACTS_FUND]: {
                [BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED]: [
                    { className: 'broker-orders-and-movements-activity__collapsables' },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationDateConsolidated" />
                        )
                    },
                    { component: <FormattedText value="broker-ordersAndMovementsActivityOperation" /> },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationImport" />
                        )
                    },
                    {
                        component: <FormattedText value="broker-ordersAndMovementsActivityValueDateConsolidated" />,
                        className: 'broker-orders-and-movements-activity__value-date'
                    },
                    { clear: true }
                ],
                [BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED]: [
                    { className: 'broker-orders-and-movements-activity__collapsables' },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationDateNulled" />
                        )
                    },
                    { component: <FormattedText value="broker-ordersAndMovementsActivityOperation" /> },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationImport" />
                        )
                    },
                    {
                        component: <FormattedText value="broker-ordersAndMovementsActivityValueDateNulled" />,
                        className: 'broker-orders-and-movements-activity__value-date'
                    },
                    { clear: true }
                ],
                [BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING]: [
                    { className: 'broker-orders-and-movements-activity__collapsables' },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationDatePending" />)
                    },
                    { component: <FormattedText value="broker-ordersAndMovementsActivityOperation" /> },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationImport" />
                        )
                    },
                    {
                        component: <FormattedText value="broker-ordersAndMovementsActivityValueDatePending" />,
                        className: 'broker-orders-and-movements-activity__value-date'
                    },
                    { clear: true }
                ],
            },
            [BROKER_JOINT_CONTRACTS_PLAN]: {
                [BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC]: [
                    { className: 'broker-orders-and-movements-activity__collapsables' },
                    { component: <FormattedText value="broker-contractActivityDate" /> },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityPeriodicity" />
                        )
                    },
                    {
                        component: <FormattedText value="broker-ordersAndMovementsActivityImport" />
                    },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityLastGiven" />
                        )
                    },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityNextGiven" />
                        )
                    },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivitySituation" />
                        ),
                        className: 'broker-orders-and-movements-activity__state'
                    },
                    { clear: true }
                ],
                [BROKER_ORDERS_AND_MOVEMENTS_PLAN_EXTRAORDINARY]: [
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationDate" />
                        )
                    },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperation" />
                        )
                    },
                    {
                        component: <FormattedText value="broker-ordersAndMovementsActivityImport" />
                    },
                    {
                        component: <FormattedText value="broker-contractActivityState" />,
                        className: 'broker-orders-and-movements-activity__state'
                    },
                    { clear: true }
                ],
                [BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES]: [
                    { clear: true },
                    { component: (<FormattedText value="broker-ordersAndMovementsPlanPendingMovesOperationName" />) },
                    { component: (<FormattedText value="broker-ordersAndMovementsPlanPendingMovesOperationsQuantity" />), className: 'broker-orders-and-movements-activity__state' }
                ],
                [BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER]: [
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperationDate" />
                        )
                    },
                    {
                        component: (
                            <FormattedText value="broker-ordersAndMovementsActivityOperation" />
                        )
                    },
                    {
                        component: <FormattedText value="broker-ordersAndMovementsActivityImport" />
                    },
                    {
                        component: <FormattedText value="broker-contractActivityState" />,
                        className: 'broker-orders-and-movements-activity__state'
                    }
                ]
            },
            [BROKER_JOINT_CONTRACTS_CRYPTO]: [
                { className: 'broker-orders-and-movements-activity__collapsables' },
                { component: <FormattedText value="broker-contractActivityDate" /> },
                {
                    className: 'broker-orders-and-movements-activity__order',
                    component: (
                        <FormattedText value="broker-ordersAndMovementsActivityDetailsOrderNumber" />
                    )
                },
                {
                    className: 'broker-orders-and-movements-activity__value',
                    component: <FormattedText value="broker-contractActivityCrypto" />
                },
                {
                    className: 'broker-orders-and-movements-activity__operation',
                    component: <FormattedText value="broker-contractActivityOperation" />
                },
                {
                    className: 'broker-orders-and-movements-activity__state',
                    component: <FormattedText value="broker-contractActivityState" />
                },
                { clear: true }
            ],
        };
        const contractType = immContract.get('type');
        const contractHeaderData = headersData[contractType];
        const currentHeaderData = !Array.isArray(contractHeaderData)
            ? contractHeaderData[selectedOption.value]
            : contractHeaderData;
        const columns = currentHeaderData.map((column, index) => {
            if (column.clear) {
                return <OKTableCell asHeader={true} key={index} />;
            }
            else if (!column.component && !!column.className) {
                return <OKTableCell asHeader={true} key={index} className={column.className} />;
            }
            else {
                return (
                    <OKTableCell asHeader={true} key={index} className={column.className || ''}>
                        {column.component}
                    </OKTableCell>
                );
            }
        });

        return (
            <thead>
                <OKTableRow asHeader={true}>
                    {columns}
                </OKTableRow>
            </thead>
        );
    }

    buildTable() {
        const { immActivities, immContract, selectedOption, immRejectedActivities } = this.props;

        const contractId = immContract.get('walletNumber');
        const immActivitiesById = immActivities.getIn([contractId, 'byId']);
        const immActivitiesByOrder = immActivities.getIn([contractId, 'byOrder']);

        const immRejectedActivitiesById = immRejectedActivities.getIn([contractId, 'byId']);
        const immRejectedActivitiesByOrder = immRejectedActivities.getIn([contractId, 'byOrder']);

        const hasPeriodicActivities =
            immActivitiesById &&
            (immActivitiesById).size > 0 &&
            (selectedOption
                ? selectedOption.value == BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC
                : true
            );

        const hasPlanOtherActivities =
            immActivitiesById &&
            (immActivitiesById).size > 0 &&
            (selectedOption
                ? selectedOption.value == BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER
                : true
            );

        let content;

        let hasActivities = immActivitiesById && immActivitiesById.size > 0;
        const hasRejectedActivities =
            immRejectedActivities.getIn([contractId, 'isRejectedActivity']) &&
            (selectedOption ?
                selectedOption.value == BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER :
                true
            );

        hasActivities = hasActivities || hasRejectedActivities;

        if (immActivities.getIn([contractId, 'error'])) {
            if (
                NO_RESULTS_ERRORS.includes(
                    immActivities.getIn([contractId, 'error', 'body', 'error'])
                )
            ) {
                return this.buildEmptyState();
            }

            if (
                immActivities.getIn([contractId, 'error', 'body', 'error']) ==
                BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC_NO_RESULTS
            ) {
                return this.buildEmptyState('broker-contractActivityPeriodicPlanEmpty');
            }

            return this.buildError();
        }

        let byOrderActivities, byIdActivities, colsCount;

        byOrderActivities = immActivitiesByOrder;
        byIdActivities = immActivitiesById;
        colsCount = 4;

        if (hasPeriodicActivities) {
            colsCount = 9;
        }
        else if (hasRejectedActivities && hasPlanOtherActivities) {

            const mergedActivities = this.mergeActivities();

            byOrderActivities = mergedActivities.combinedOtherActivitiesByOrder;
            byIdActivities = mergedActivities.combinedOtherActivitiesById;

        }
        else if (hasRejectedActivities) {
            byOrderActivities = immRejectedActivitiesByOrder;
            byIdActivities = immRejectedActivitiesById;
        }

        if (hasActivities) {
            const tableHeader = this.buildTableHeader(immContract, selectedOption);

            // sort activities by date (from newer to older)
            const sortedByDateActivities = byOrderActivities
                .map(activityId => byIdActivities.get(activityId))
                .sort((activityA, activityB) => {
                    // "dateValue" = "YYYY-MM-DD"
                    const timestampA = new Date(activityA.get('dateRequested')).getTime()
                    const timestampB = new Date(activityB.get('dateRequested')).getTime()
                    return timestampB - timestampA
                })
                .map(activity => activity.get('id'))

            content = (
                <LastMovementsTable
                    groupByDate={false}
                    rowComponent={BrokerOrdersAndMovementsActivityTableRow}
                    immTransactionsByOrder={sortedByDateActivities}
                    immTransactionsById={byIdActivities}
                    columnsCount={colsCount}
                    expandedRowId={this.state.expandedRowId}
                    expandedRowComponent={BrokerOrdersAndMovementsActivityDetails}
                    onRowClick={this.handleRowClick}
                    id={'broker-orders-and-movements-activity'}
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    {tableHeader}
                </LastMovementsTable>
            );
        }
        else {
            content = this.buildEmptyState();
        }

        return content
    }

    render() {
        const { immActivities, immContract, flagBasedFeatures, immOrdersAndMovements } = this.props;
        const contractId = immContract.get('walletNumber');
        const isLoading =
            immActivities.size === 0 ||
            !immActivities.get(contractId) ||
            immActivities.getIn([contractId, 'isFetching']);
        const isSuccess = immActivities.getIn([contractId, 'success']);
        let content, headerAndFilter;
        const ffContribution = flagBasedFeatures.get('wealth_funds_periodic_contributions');
        const immFilter = immActivities.getIn([contractId, 'filters']);

        if (isLoading) {
            content = <LoadingSection />;
        }
        else {
            const isOrderValue = immContract.get('type') === BROKER_JOINT_CONTRACTS_VALUE;
            const isOrderCrypto = immContract.get('type') === BROKER_JOINT_CONTRACTS_CRYPTO;
            content = this.buildTable();

            if (isOrderValue || isOrderCrypto) {
                headerAndFilter = (
                    <section>
                        <BrokerOrdersAndMovementsActivityFilter
                            contractId={contractId}
                            immFilter={immFilter}
                            isModalOpen={this.state.filterSettingsOpen}
                            setFilter={this.setFilter}
                            onCloseClick={this.handleToggleFilters}
                        />
                        <BrokerOrdersAndMovementsActivityHeader
                            immContract={immContract}
                            immFilter={immFilter}
                            onFilterClick={this.handleToggleFilters}
                            clearFilter={this.clearFilter}
                            isSuccess={isSuccess}
                        />
                    </section>
                );
            } else if(ffContribution && immContract.get('type') === BROKER_JOINT_CONTRACTS_FUND) {
                const stateOperation = immOrdersAndMovements ? immOrdersAndMovements.get('stateOperation') : '';
                const dateStart = immOrdersAndMovements && immOrdersAndMovements.getIn(['dateForFilter','from']);
                const dateEnd = immOrdersAndMovements && immOrdersAndMovements.getIn(['dateForFilter','to']);
                const isCheckContributions = immOrdersAndMovements && immOrdersAndMovements.get('isCheckContributions');
                const isCheckSubscription = immOrdersAndMovements && immOrdersAndMovements.get('isCheckSubscription');
                const isCheckReimbursement = immOrdersAndMovements && immOrdersAndMovements.get('isCheckReimbursement');
                const isCheckTransfer = immOrdersAndMovements && immOrdersAndMovements.get('isCheckTransfer');
                headerAndFilter = (
                    <div className="broker-orders-and-movements-activity-filters__container">
                        <div className="broker-orders-and-movements-activity-header__labels">
                            <div className="broker-orders-and-movements-activity-header__state-label">
                                <FormattedText value="broker-ordersAndMovementsActivityStateOperation" />
                                {stateOperation}
                            </div>
                        </div>
                        <div className="broker-orders-and-movements-activity-header__labels">
                            <div className="broker-orders-and-movements-activity-header__state-label">
                                <FormattedText value="broker-ordersAndMovementsActivityDateOperation"/>
                                {dateStart} - {dateEnd}
                            </div>
                        </div>
                        {
                            isCheckContributions &&
                                <div className="broker-orders-and-movements-activity-header__labels">
                                    <div className="broker-orders-and-movements-activity-header__state-label">
                                        <FormattedText value="broker-ordersAndMovementsActivityTypeOperation"/>:
                                        <FormattedText value="broker-ordersAndMovementsActivityPeriodicalContributions"/>
                                    </div>
                                </div>
                        }
                        {
                            isCheckSubscription &&
                                <div className="broker-orders-and-movements-activity-header__labels">
                                    <div className="broker-orders-and-movements-activity-header__state-label">
                                        <FormattedText value="broker-ordersAndMovementsActivityTypeOperation"/>:
                                        <FormattedText value="broker-ordersAndMovementsActivitySubscription"/>
                                    </div>
                                </div>
                        }
                        {
                            isCheckReimbursement &&
                                <div className="broker-orders-and-movements-activity-header__labels">
                                    <div className="broker-orders-and-movements-activity-header__state-label">
                                        <FormattedText value="broker-ordersAndMovementsActivityTypeOperation"/>:
                                        <FormattedText value="broker-ordersAndMovementsActivityReimbursement"/>
                                    </div>
                                </div>
                        }
                        {
                            isCheckTransfer &&
                                <div className="broker-orders-and-movements-activity-header__labels">
                                    <div className="broker-orders-and-movements-activity-header__state-label">
                                        <FormattedText value="broker-ordersAndMovementsActivityTypeOperation"/>:
                                        <FormattedText value="broker-ordersAndMovementsActivityTransfer"/>
                                    </div>
                                </div>
                        }
                    </div>
                );
            }
        }

        return (
            <div>
                {ffContribution && immContract.get('type') === BROKER_JOINT_CONTRACTS_FUND && (
                    <div className='broker-orders-and-movements-activity__new-filter'>
                        <ModalOrderAndMovementsFilter
                            isOpenModal={this.state.openModalForNewFilters}
                            openModal={() => this.setState({openModalForNewFilters: false})}
                            immFilter={immFilter}
                            immContract={immContract}
                        />
                        <OKButton
                            id="btn_accountLastMovementsHeader_filterButton"
                            modifier="task"
                            onClick={() => this.setState({openModalForNewFilters: true})}
                        >
                            <OKTooltip
                                type="descriptive"
                                target={
                                <i className="icon icon-filtrar broker-orders-and-movements-activity-header__filter-settings-icon" />
                                }
                                content={
                                    <FormattedText
                                        value="broker-ordersAndMovementsActivityFilterButton"
                                        format="uppercase"
                                    />
                                }
                                offset={[-5, -25]}
                            />
                        </OKButton>
                        <FormattedText value="broker-ordersAndMovementsActivityFilterButton"/>
                    </div>
                )}
                {headerAndFilter}
                {content}
            </div>
        );
    }
}

BrokerOrdersAndMovementsActivity.propTypes = {
    immContract: PropTypes.object.isRequired,
    immActivities: PropTypes.object.isRequired,
    immRejectedActivities: PropTypes.object.isRequired,
    getContractActivities: PropTypes.func.isRequired,
    getRejectedActivities: PropTypes.func,
    setFilter: PropTypes.func,
    clearFilter: PropTypes.func,
    selectedOption: PropTypes.object,
    history: PropTypes.object.isRequired,
    immOrdersAndMovements: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = withRouter(BrokerOrdersAndMovementsActivity);
